<style lang="scss"></style>

<template>
  <div class="add-app-modal">
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(addMonitor)">

        <section class="mb-1">
          <validation-provider
            v-slot="validationContext"
            name="Prisoner Number"
            :rules="{ required: true, prisonerNumberFormat: true }"
          >
            <label>{{ $options.filters.term('prisoner', true) }} Number</label>
            <b-form-input
              v-model.trim="monitor.prisoner_number"
              cy="add-monitor-prison-number-input"
              :state="getValidationState(validationContext)"
              :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
            />
            <b-form-invalid-feedback v-if="validationContext.errors[0]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </validation-provider>
        </section>

        <section class="mb-1">
          <label class="text-capitalize">Auto Assign to Staff Member for Approval</label>
          <validation-provider
            v-slot="validationContext"
            name="PrisonerNumber"
            :rules="{ required: false }"
          >
            <b-form-select v-model="monitor.auto_assign_clinician_user_id" cy="input-select-staff"
                           :state="getValidationState(validationContext)" :class="{'disabled': !clinicians}">
              <b-form-select-option disabled value="">Select a staff member</b-form-select-option>
              <b-form-select-option :value="null">No Assignment</b-form-select-option>
              <b-form-select-option v-for="user in clinicians" :key="user.user_id" :value="user.user_id">{{ user.name }}</b-form-select-option>
            </b-form-select>

            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </section>

        <section class="mb-2">
          <label>Reason</label>
          <validation-provider
            v-slot="validationContext"
            name="Reason"
            :rules="{ required: false }"
          >
            <b-form-textarea
              v-model="monitor.reason"
              rows="3"
              max-rows="6"
              :state="getValidationState(validationContext)" class="mb-1" placeholder="Enter a reason"
            />

            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </validation-provider>
        </section>

        <section class="d-inline-flex full-width mt-2">
          <div class="ui-spacer" />
          <b-button class="mr-2" @click="$emit('close', true)">Cancel</b-button>
          <b-button type="submit" variant="primary">Add Mail Monitor</b-button>
        </section>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import MailMonitorService from '@/services/MailMonitorService';
import { mapState } from 'vuex';

export default {
  components: {},
  props: {},
  data() {
    return {
      monitor: {
        prisoner_number: '',
        reason: '',
        auto_assign_clinician_user_id: '',
      },
    };
  },
  computed: {
    ...mapState({
      clinicians: state => state.postCard.clinicians,
    }),
  },
  mounted() {
    if (!this.clinicians.length) {
      this.$store.dispatch('postCard/refreshClinicians');
    }
  },
  methods: {
    addMonitor() {
      MailMonitorService.createMonitor(this.monitor).then(() => {
        this.$toast.success(`Added Mail Monitor for ${this.monitor.prisoner_number} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.$emit('refresh', true);
      }).catch(err => {
        let errorMsg = 'Could not add mail monitor, please refresh and try again';

        if (err.response && err.response.data && err.response.data.error === 'ENTITY_ALREADY_EXISTS') {
          errorMsg = `Could not add monitor as one already exists with this ${this.$options.filters.term('prisoner')} + ' Number'`;
        }

        this.$toast.error(errorMsg, {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
};
</script>
